export default "__VITE_ASSET__23137f6f__"